import {axiosPrivate} from "../axios-config/axiosPrivate";
import {standardRequestConfig} from "../axios-config/requestConfig";
import {BACKEND} from "../config/backend";

export const getTermin = ({terminId, kundId}) => {
    return axiosPrivate.get(`${BACKEND}/api/v1/termine/${terminId}`, {
        ...standardRequestConfig
        , params: kundId && {kundid: kundId}
    })
}

export const saveTermin = ({terminData}) => {
    return axiosPrivate.post(`${BACKEND}/api/v1/termine/`, terminData, {
        ...standardRequestConfig
    })
}

export const deleteTermin = ({terminId}) => {
    return axiosPrivate.delete(`${BACKEND}/api/v1/termine/${terminId}`, {
        ...standardRequestConfig
    })
}

export const searchTermine = ({parameters}) => {
    return axiosPrivate.get(`${BACKEND}/api/v1/termine`, {
        ...standardRequestConfig
        , params: parameters
    })
}

export const searchEinnahmen = ({parameters}) => {
    return axiosPrivate.get(`${BACKEND}/api/v1/termine/einnahmen`, {
        ...standardRequestConfig
        , params: parameters
    })
}

export const updateTerminList = ({parameters}) => {
    return axiosPrivate.put(`${BACKEND}/api/v1/termine/list`, parameters,{
        ...standardRequestConfig
    })
}

export const importICalTermine = ({icalTermine}) => {
    return axiosPrivate.post(`${BACKEND}/api/v1/termine/icalimport`, icalTermine, {
        ...standardRequestConfig
    })
}
